const messages = {
  title: 'Interna greška',
  description: 'Podaci za ovu stranicu ne mogu biti ispravno učitani.',
  backHomeButton: 'Natrag na nadzornu ploču'
}

export default {
  messages
}
